// TODO - Documentar
import { useDispatch, useSelector } from 'react-redux';

import * as con from "../../GlobalConstants"
import { setModelParameter, updateTermInMonths } from '../../store/slices/modelParametersSlice';


/**
 * Hook for all model parameter in the store 
 */
 export function AllModelParameterHook() {

    const value = useSelector(state => state[con.REDUCER_MODEL_PARAMETERS])


    return(value);
}



/**
 * Hook for a single model parameter in the store read only
 */
export function RefModelParameterHook(parameterName) {

    const value = useSelector(state => state[con.REDUCER_MODEL_PARAMETERS][parameterName])


    return(value);
}


/**
 * Hook for a single nested model parameter in the store read only
 */
 export function RefNestedModelParameterHook(parameterName, attributeName) {

    const value = useSelector(state => state[con.REDUCER_MODEL_PARAMETERS][parameterName][attributeName])

    return(value);
}


/**
 * Hook for a single model parameter in the store (read & write)
 */
export function StateModelParameterHook(parameterName) {
  const dispatch = useDispatch();

  const value = useSelector(
    (state) => state[con.REDUCER_MODEL_PARAMETERS][parameterName]
  );

  const setParameter = (newVal) => {

    const customDispatcher =
      modelParameterDispatchMap[parameterName];

    if (customDispatcher) {
      dispatch(customDispatcher(parameterName, newVal));
    } else {
      dispatch(
        setModelParameter({
          id: parameterName,
          value: newVal,
        })
      );
    }
  };

  return [value, setParameter];
}


/**
 * Hook for a single model value in the store. Only write
 */
export function EditModelValueHook(parameterName) {
  const dispatch = useDispatch();

  const setParameter = (newVal) => {
    const customDispatcher =
      modelParameterDispatchMap[parameterName];

    if (customDispatcher) {
      dispatch(customDispatcher(parameterName, newVal));
    } else {
      dispatch(
        setModelParameter({
          id: parameterName,
          value: newVal,
        })
      );
    }
  };

  return setParameter;
}




export const modelParameterDispatchMap = {
  [con.TERM_PERIODICITY]: updateTermInMonths,
  [con.PERIODICITY]: updateTermInMonths,
};